var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0442878 8.80285C-0.435162 4.36794 3.03936 0.497559 7.50011 0.497559C11.9609 0.497559 15.4354 4.36795 14.9559 8.80286L14.4902 13.1111C14.3431 14.4715 13.1946 15.5026 11.8262 15.5026H11.6426C9.95174 15.5026 8.68356 13.9557 9.01517 12.2976L9.37243 10.5113C9.62292 9.25887 10.7226 8.35734 11.9999 8.35734H13.2018C13.4119 5.0862 10.813 2.28387 7.50011 2.28387C4.18719 2.28387 1.58834 5.0862 1.79841 8.35734H2.99755C4.2748 8.35734 5.3745 9.25887 5.62499 10.5113L5.98225 12.2976C6.31386 13.9557 5.04568 15.5026 3.35481 15.5026H2.67567C2.18239 15.5026 1.78251 15.1027 1.78251 14.6094C1.78251 14.1162 2.18239 13.7163 2.67567 13.7163H3.35481C3.91844 13.7163 4.34116 13.2006 4.23063 12.648L3.87336 10.8616C3.78987 10.4442 3.4233 10.1436 2.99755 10.1436H1.98596L2.16982 11.8443C2.27585 12.8252 1.56668 13.7062 0.585847 13.8123L0.0442878 8.80285ZM13.0143 10.1436H11.9999C11.5741 10.1436 11.2076 10.4442 11.1241 10.8616L10.7668 12.648C10.6563 13.2006 11.079 13.7163 11.6426 13.7163H11.8262C12.2824 13.7163 12.6652 13.3726 12.7142 12.9191L13.0143 10.1436Z",
    fill: "#6171FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.8b71e35a.svg";
export { ForwardRef as ReactComponent };